const PANEL_WIDTH = 352;
const GAP = 16;
const VIEWPORT_PAD = 16;
const MIN_WIDTH = 240;

export type TextCodePanelBox = {
  top: number;
  left: number;
  width: number;
  maxHeight: number;
};

/** Place the code list to the right of the Mine tekster column, inside the viewport. */
export function placeTextCodePanel(
  column: { top: number; right: number },
  viewport: { width: number; height: number },
): TextCodePanelBox {
  const top = Math.min(
    Math.max(column.top, VIEWPORT_PAD),
    Math.max(VIEWPORT_PAD, viewport.height - 240),
  );
  const maxHeight = Math.max(200, viewport.height - top - VIEWPORT_PAD);
  const room = viewport.width - column.right - GAP - VIEWPORT_PAD;
  if (room >= MIN_WIDTH) {
    return {
      top,
      left: column.right + GAP,
      width: Math.min(PANEL_WIDTH, room),
      maxHeight,
    };
  }
  const width = Math.min(PANEL_WIDTH, Math.max(0, viewport.width - VIEWPORT_PAD * 2));
  return {
    top,
    left: Math.max(VIEWPORT_PAD, viewport.width - width - VIEWPORT_PAD),
    width,
    maxHeight,
  };
}
